// Data structure for vault events
const vaultEvents = [
  {
    id: 'originals-adidas-trench',
    title: 'ORIGINALS',
    subtitle: 'ADIDAS LDN X TRENCH',
    date: '28TH SEPT',
    time: '19:30 - 23:00',
    venue: 'ADIDAS LDN',
    location: 'OXFORD STREET',
    postcode: 'W1C 2PG',
    posterImage: 'Trench x Adidas.jpeg',
    featuredArtists: [
      'JME',
      'Ruff Sqwad',
      'DJ Slimzee',
      'Sherelle',
      'Joce Wavy',
      'Yeahitsrenee',
      'Travs Presents'
    ],
    description: 'A special night at Adidas LDN featured an all-star lineup hosted by Sian Anderson (BBC Radio 1Xtra). The exclusive evening brought together JME, Ruff Sqwad, and a stellar supporting cast including DJ Slimzee, Sherelle, Joce Wavy, and Yeahitsrenee. The event also featured a special talk with Labrum London & Ian Wright, with exclusive product & gift with purchase, drinks & refreshments provided.',
    photos: [],
    videoId: '',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'end-of-year-2023',
    title: 'TRAVS PRESENTS',
    subtitle: 'END OF YEAR PARTY 2023',
    date: '29TH DEC',
    time: '19:00 - 01:00',
    venue: 'MOKOS',
    location: 'LONDON',
    postcode: 'N15 4QA',
    posterImage: 'EOY 23.jpg',
    featuredArtists: [
      'Sicaria',
      'DJ Oblig',
      'Teddy Bones',
      'More'
    ],
    description: 'We closed out 2023 with a massive end of year celebration at Mokos. A heavyweight lineup featured the energetic sounds of Sicaria, DJ Oblig, and Teddy Bones, plus more special guests to be announced. Join us at our new home on Markfield Road for one final dance of the year.',
    photos: ['Website Upgrade/EOy 24/Pics/G3n3graphy/Copy of IMG_1508.jpeg',
      'Website Upgrade/EOy 24/Pics/G3n3graphy/Copy of IMG_1615.jpeg',
      'Website Upgrade/EOy 24/Pics/G3n3graphy/Copy of IMG_1504.jpeg',
      'Website Upgrade/EOy 24/Pics/G3n3graphy/Copy of IMG_1518.jpeg',
      'Website Upgrade/EOy 24/Pics/G3n3graphy/Copy of IMG_1634.jpeg',
      'Website Upgrade/EOy 24/Pics/G3n3graphy/Copy of IMG_1397.jpeg',
    ],
    videoId: 'L0KyqqM_kcw',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'popup-logan-sama',
    title: 'TRAVS POP-UP PRESENTS',
    subtitle: 'LOGAN SAMA & HENDY',
    date: '28TH FEB',
    time: '9PM - 12AM',
    venue: 'KHUSH',
    location: 'LONDON',
    postcode: 'N15 4QA',
    posterImage: '2024 Pop Up.jpg',
    featuredArtists: [
      'Logan Sama',
      'Hendy',
      'Special Guests'
    ],
    description: 'Travs Pop-Up brought an intimate night with grime pioneer Logan Sama and the dynamic Hendy, plus special guests. The night took over Khush for a high-energy session of cutting-edge sounds and classic selections. Limited capacity ensured maximum vibes, powered by Wing Stop.',
    photos: [],
    videoId: 'ZKJJgnxE9lc',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'clash-novelist',
    title: 'CLASH',
    subtitle: 'NOVELIST',
    date: '21ST SEPTEMBER',
    time: '10PM - 3AM',
    venue: 'FABRIC',
    location: 'LONDON',
    postcode: 'EC1M 6HJ',
    posterImage: 'clash_tp_poster.png',
    featuredArtists: [
      'NOVELIST',
      'SHARKY MAJOR',
      'SIR SPYRO',
      'FOOTSIE',
      'JAMMER',
      'MR VIRGO'
    ],
    description: 'CLASH brought the legendary Novelist to Fabric for an unprecedented night of grime and bass music. Joined by pioneers Sharky Major, Sir Spyro, and Jammer, this event represented a historic moment in London\'s underground music scene. The night featured raw energy of live performances and wheel-ups in one of the city\'s most iconic venues, with Mr Virgo providing the foundation on production duties.',
    photos: ['Website Upgrade/Clash 2024/Grime_visuals/Copy of 000163510003.jpg',
      'Website Upgrade/Clash 2024/Grime_visuals/Copy of 000163510008.jpg',
      'Website Upgrade/Clash 2024/Grime_visuals/Copy of 000163510011.jpg',
      'Website Upgrade/Clash 2024/Grime_visuals/Copy of 000163510014.jpg',
      'Website Upgrade/Clash 2024/Grime_visuals/Copy of 000163510018.jpg',
      'Website Upgrade/Clash 2024/Grime_visuals/Copy of 000163510016.jpg',
    ],
    videoId: '',
    videoThumbnail: 'clash_tp_thumbnail.png',
    recapVid: ''
  },
  {
    id: 'kruz-two-footed',
    title: 'KRUZ LEONE TWO FOOTED',
    subtitle: '2 FOOTED',
    date: '10TH OCT',
    time: '8PM - 1AM',
    venue: 'KNOCKED',
    location: 'SHOREDITCH',
    postcode: 'EC2A 3AY',
    posterImage: 'kruz_two_footed_poster.png',
    featuredArtists: [
      'Kruz Leone',
      'Keezie',
      'Desperado',
      'Graft',
      'Pxshy',
      'Splurgeboys'
    ],
    description: 'Kruz Leone brought his explosive \'2 FOOTED\' show to Knocked, Shoreditch. The night delivered raw energy and unmatched talent as Kruz shared the stage with some of the scene\'s most exciting artists. From KEEZIE\'s dynamic performance to the SPLURGEBOYS\' crowd-moving sets, this night marked a landmark event in East London\'s music calendar.',
    photos: [],
    videoId: 'jzpB-Ps2n0I',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'no-remorse-jammz-friends',
    title: 'NO REMORSE',
    subtitle: 'JAMMZ & FRIENDS',
    date: '14TH NOVEMBER',
    time: '8PM - 12AM',
    venue: 'FOUR QUARTERS',
    location: 'PECKHAM',
    postcode: 'SE15 4TW',
    posterImage: 'jammz_no_remorse_poster.png',
    featuredArtists: [
      'JAMMZ',
      'MANGA SAINT HILARE',
      'PK',
      'MAXSTA',
      'MOBB DEEP',
      'BRAKKA',
      'PROZAK',
      'PLASTICIAN',
      'JACKDAT',
      'MORE'
    ],
    description: 'NO REMORSE returned to Four Quarters Peckham with JAMMZ hosting a special edition featuring an all-star lineup. The night showcased the legendary Manga Saint Hilare alongside scene veterans PK and Maxsta, with Plastician and Jackdat bringing their signature sounds to the mix. This intimate venue was transformed into a hub of underground energy, featuring arcade games and an unmatched atmosphere.',
    photos: [],
    videoId: '',
    videoThumbnail: 'jammz_no_remorse_thumbnail.png',
    recapVid: ''
  },
  {
    id: 'end-of-year-2024',
    title: 'END OF YEAR PARTY 2024',
    date: '27TH DEC',
    time: '8PM - 2AM',
    venue: 'ORANGE ROOM',
    location: 'STRATFORD',
    postcode: 'E15 4QZ',
    posterImage: 'TP_EOY_2024_poster.png',
    featuredArtists: [
      'MAK10 (FUNKY SET)',
      'Grandmixxer',
      'Trezzor',
      'Tsunamy',
      'Ali Velmi',
      'Special Guests'
    ],
    description: 'Our massive End of Year celebration at Orange Room, Stratford featured an incredible lineup of artists, including a special funky set from MAK10 and the legendary GRANDMIXXER. The event delivered an unforgettable night of music, energy, and pure vibes. With a state-of-the-art sound system and an electric atmosphere, we brought together some of the scene\'s finest talents to close out 2024 in style.',
    photos: ['Website Upgrade/Eoy 23/Pics/Copy of 000065570008-Recovered.gif',
      'Website Upgrade/Eoy 23/Pics/Copy of 000065570061.gif',
      'Website Upgrade/Eoy 23/Pics/Copy of 000065570014.gif',
      'Website Upgrade/Eoy 23/Pics/Copy of 000065570020.gif',
      'Website Upgrade/Eoy 23/Pics/Copy of 000065570026.gif',
      'Website Upgrade/Eoy 23/Pics/Copy of 000065570067.gif',
    ],
    videoId: 'azsHs7o7ksk',
    videoThumbnail: 'end_of_year_2024_thumbnail.png',
    recapVid: ''
  },
  {
    id: 'lengbaby-amsterdam',
    title: 'LENGBABY INVITES TRAVS PRESENTS',
    subtitle: 'SETS & SELECTIONS',
    date: '17TH OCT',
    time: '21:00 - 05:00',
    venue: 'SEXYLAND WORLD',
    location: 'NOORD',
    postcode: 'NL-1033',
    posterImage: 'Amsterdam.jpg',
    featuredArtists: [
      'Chamber45',
      'Si*bl',
      'Duppy',
      'Kruz Leone',
      'Renz',
      'Babydoom',
      'Teddy Bones',
      'Jill-Ann',
      'Man Like Axel'
    ],
    description: 'Lengbaby brought an explosive night of UK and NL talent to Amsterdam\'s Sexyland World. The night featured an all-star lineup of selectors and performers, uniting the finest sounds from both scenes. From Chamber45\'s dynamic sets to Kruz Leone\'s energetic performance, the night delivered groundbreaking music and unforgettable moments.',
    photos: [],
    videoId: '',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'adidas-uk-music-archive',
    title: 'ADIDAS & THE UK MUSIC ARCHIVE',
    subtitle: 'DA METAL MESSIAH PRESENTS',
    date: '21ST SEPT',
    time: '17:00 - 21:00',
    venue: 'THE BASEMENT',
    location: 'SOHO',
    postcode: 'W1F 9JY',
    posterImage: 'DMM X TP X Adidas.jpg',
    featuredArtists: [
      'Benson B',
      'Travspresents',
      'Surprise Guests'
    ],
    description: 'In this exclusive exhibition, UK music archivist @dametalmessiah connected the dots to create a tapestry of adidas\' indelible influence on British style, music, and beyond. The evening at 59 Greek Street featured special sets from Benson B and Travspresents, with surprise guests throughout the night.',
    photos: [
      'Website Upgrade/TP DMM ADIDAS/Pics/Copy of 63210012.gif',
      'Website Upgrade/TP DMM ADIDAS/Pics/Copy of 63210013.gif',
      'Website Upgrade/TP DMM ADIDAS/Pics/Copy of 63210016.gif',
      'Website Upgrade/TP DMM ADIDAS/Pics/Copy of 63210024.gif',
      'Website Upgrade/TP DMM ADIDAS/Pics/Copy of 63210019.gif',
      'Website Upgrade/TP DMM ADIDAS/Pics/Copy of 63210025.gif',
    ],
    videoId: 'scbAgmMCvkE',
    videoThumbnail: '',
    recapVid: ''
  },

  {
    id: '2nd-birthday-party',
    title: '2ND BIRTHDAY',
    subtitle: 'PARTY',
    date: '5TH AUGUST',
    time: '9PM - 4AM',
    venue: 'CORSICA STUDIOS',
    location: 'ELEPHANT & CASTLE',
    postcode: 'SE17 1LB',
    posterImage: '2nd_bday_poster.png',
    featuredArtists: [
      'FLOWDAN',
      'BIG ZUU',
      'D DOUBLE E',
      'CHIMPO',
      'ROSSI B',
      'BADGER'
    ],
    description: 'Celebrating two years of groundbreaking events, we took over Corsica Studios with a stellar lineup featuring grime royalty. Flowdan, D Double E, and Big Zuu headlined this milestone event, supported by the versatile sounds of Chimpo and the dynamic duo Rossi B & Badger. The night brought an intimate celebration to one of London\'s most respected underground venues.',
    photos: [],
    videoId: 'ijGq22iBlxc',
    videoThumbnail: '2nd_bday_thumbnail.png',
    recapVid: ''
  },
  {
    id: 'kozzie-and-friends',
    title: 'TRAVS PRESENTS',
    subtitle: 'KOZZIE & FRIENDS',
    date: '20TH JUL',
    time: '19:00 - 23:00',
    venue: 'FOUR QUARTERS',
    location: 'PECKHAM',
    postcode: 'SE15 4TW',
    posterImage: 'Kozzie n friends.jpg',
    featuredArtists: [
      'Sbuers',
      'Guido.yz',
      'Chamber.45',
      'B2B Si*bl',
      'Special Guests'
    ],
    description: 'Travs Presents brought Kozzie & Friends to Four Quarters Peckham for an intimate night of raw energy. The night featured a stellar lineup including Sbuers, Guido.yz, Chamber.45 going back to back with Si*bl, plus special guests. 18+ event with ID required.',
    photos: [
      'Website Upgrade/Kozzie n friends/Pics/Copy of 5.jpg',
      'Website Upgrade/Kozzie n friends/Pics/Copy of 37.jpg',
      'Website Upgrade/Kozzie n friends/Pics/Copy of 35.jpg',
      'Website Upgrade/Kozzie n friends/Pics/Copy of 45.jpg',
      'Website Upgrade/Kozzie n friends/Pics/Copy of 32.jpg',
      'Website Upgrade/Kozzie n friends/Pics/Copy of 50.jpg',
    ],
    videoId: '',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'travs-dijonss',
    title: 'TRAVS PRESENTS',
    subtitle: 'X DIJONSS',
    date: '11TH AUG',
    time: '6PM - 12AM',
    venue: 'THE OLD TRUMAN BREWERY',
    location: 'LONDON',
    postcode: 'E1 6QL',
    posterImage: 'Tp Dijonss.jpg',
    featuredArtists: [
      'Manga St. Hilare',
      'So Large',
      'Grandmixxer',
      'Dndy',
      'Teddy Bones',
      'Geezr',
      'Sustrapperazzi',
      'Soltura',
      'Special Guests'
    ],
    description: 'Travs Presents joined forces with Dijonss for a monumental night at The Old Truman Brewery. The night was headlined by grime veteran Manga St. Hilare, alongside So Large and the legendary Grandmixxer bringing their crews. The event featured an extensive lineup of selectors including Dndy, Teddy Bones, Geezr, Sustrapperazzi, and Soltura, delivering a diverse mix of underground sounds.',
    photos: ['Website Upgrade/Dijonss/Pics/Copy of 000023080049.png',
      'Website Upgrade/Dijonss/Pics/Copy of 000023080053.gif',
      'Website Upgrade/Dijonss/Pics/Copy of 000023210010.gif',
      'Website Upgrade/Dijonss/Pics/Copy of 88160022.gif',
      'Website Upgrade/Dijonss/Pics/Copy of 88160014.gif',
      'Website Upgrade/Dijonss/Pics/Copy of 88160020.gif',
    ],
    videoId: 'k-cjAEz_0yo',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'first-birthday-party',
    title: 'TRAVS PRESENTS',
    subtitle: '1ST BIRTHDAY',
    date: '28TH APR',
    time: '18:00 - 00:30',
    venue: '1 LOWER CLAPTON RD',
    location: 'LOWER CLAPTON',
    postcode: 'E5 0NS',
    posterImage: '1st birthday poster.jpg',
    featuredArtists: [
      'Teddy Bones',
      'Nammy Wams',
      'General Courts',
      'Sox (Taste Dat Music)'
    ],
    description: 'We celebrated our first year of groundbreaking events at Lower Clapton Road. The night featured a stacked lineup with the heavyweight sounds of Teddy Bones and Nammy Wams, supported by General Courts and Sox from Taste Dat Music. Each artist brought their own crew of friends for an extended family celebration of underground music culture.',
    photos: ['Website Upgrade/1st Birthday Party/Pics/Copy of 001036120001.gif',
    'Website Upgrade/1st Birthday Party/Pics/Copy of 001036150025.gif',
    'Website Upgrade/1st Birthday Party/Pics/Copy of 001036130011.gif',
    'Website Upgrade/1st Birthday Party/Pics/Copy of 001036130008.gif',
    'Website Upgrade/1st Birthday Party/Pics/Copy of IMG_7672.jpeg',
    'Website Upgrade/1st Birthday Party/Pics/Copy of 001036130019.gif',
    ],
    videoId: 'xfY558As1dM',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'travs-presents-friends',
    title: 'TRAVS PRESENTS',
    subtitle: '+ FRIENDS',
    date: '15TH MOUNT PLEASANT',
    time: '8PM - 1AM',
    venue: 'RECORDS BOOKS RADIO',
    location: 'LONDON',
    postcode: 'E5 0NS',
    posterImage: 'TP 4_4_23.jpg',
    featuredArtists: [
      'Travs Presents',
      'Friends'
    ],
    description: 'A special night at KINDRED LDN featured a curated lineup of friends and selectors. The intimate evening showcased the diverse sounds of our community.',
    photos: [
      'Website Upgrade/Kindred 4-4-23/Pics/Copy of _MG_7210.jpg',
      'Website Upgrade/Kindred 4-4-23/Pics/Copy of _MG_7349.jpg',
      'Website Upgrade/Kindred 4-4-23/Pics/Copy of 000001230010.gif',
      'Website Upgrade/Kindred 4-4-23/Pics/Copy of _MG_7395.jpg',
      'Website Upgrade/Kindred 4-4-23/Pics/Copy of 000001230009.gif',
      'Website Upgrade/Kindred 4-4-23/Pics/Copy of 000001230007.gif',
    ],
    videoId: 'pemL1jVN0qw',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'reo-guido',
    title: 'REO X GUIDO.YZ',
    date: '15TH MOUNT PLEASANT',
    time: '8PM - 10PM',
    venue: 'KINDRED',
    location: 'LONDON',
    postcode: 'WC1X 0AR',
    posterImage: 'REOXGUIDO.jpg',
    featuredArtists: [
      'Reo',
      'Guido.yz'
    ],
    description: 'A special intimate session at Kindred featured Reo and Guido.yz. The evening brought underground sounds to the heart of London, with two of the scene\'s most exciting talents going back to back.',
    photos: [],
    videoId: '',
    videoThumbnail: '',
    recapVid: ''
  },
  {
    id: 'end-of-year-2022',
    title: 'TRAVS PRESENTS',
    subtitle: 'END OF YEAR',
    date: 'DECEMBER 30TH',
    time: '18:00 - 00:00',
    venue: '1 LOWER CLAPTON ROAD',
    location: 'LONDON',
    postcode: 'E5 8HB',
    posterImage: 'TP–EOY–22.jpg',
    featuredArtists: [
      'Special Guests'
    ],
    description: 'Our End of Year celebration at Lower Clapton Road delivered an intimate night of music and culture in our signature space, featuring special guests and surprise performances throughout the night.',
    photos: [],
    videoId: '18ge3BMAwEQ',
    videoThumbnail: '',
    recapVid: ''
  }
];

export default vaultEvents;

// Helper function to find event by ID
export const getEventById = (id) => {
  return vaultEvents.find(event => event.id === id) || null;
}; 